import React from 'react';
import { Star, Award, Mic2 } from 'lucide-react';
import { artistData } from '../data/mock';

const AboutSection = () => {
  return (
    <section id="about" className="py-24 bg-stone-950 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23d97706' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }} />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_alexander-richard/artifacts/dwgdixaz_IMG_0336.jpeg"
                alt="Alexander Richard with full band"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-stone-950/80 via-transparent to-transparent" />
            </div>
            
            {/* Floating Card */}
            <div className="absolute -bottom-6 -right-6 bg-stone-900 border border-stone-800 rounded-xl p-6 shadow-xl max-w-xs">
              <div className="flex items-center gap-3 mb-3">
                <Award className="w-8 h-8 text-gold-400" />
                <div>
                  <p className="text-white font-semibold">Milestone Performance</p>
                  <p className="text-stone-400 text-sm">September 2025</p>
                </div>
              </div>
              <p className="text-stone-300 text-sm">
                Opened for Ashes & Arrows (America's Got Talent) in hometown Hastings, Nebraska
              </p>
            </div>

            {/* Decorative Element */}
            <div className="absolute -top-4 -left-4 w-24 h-24 border-2 border-gold-500/30 rounded-2xl" />
          </div>

          {/* Content Side */}
          <div>
            <div className="inline-flex items-center gap-2 bg-gold-500/10 border border-gold-500/20 rounded-full px-4 py-2 mb-6">
              <Mic2 className="w-4 h-4 text-gold-400" />
              <span className="text-gold-300 text-sm font-medium">Artist Bio</span>
            </div>

            <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
              The Nebraska-Born <span className="text-gold-400">Troubadour</span>
            </h2>

            <p className="text-lg text-stone-300 mb-8 leading-relaxed">
              {artistData.bio}
            </p>

            {/* Style Section */}
            <div className="bg-stone-900/50 border border-stone-800 rounded-xl p-6 mb-8">
              <h3 className="text-white font-semibold mb-3 flex items-center gap-2">
                <Star className="w-5 h-5 text-gold-400" />
                Musical Style
              </h3>
              <p className="text-stone-300">{artistData.style}</p>
            </div>

            {/* Covered Artists */}
            <div>
              <h3 className="text-white font-semibold mb-4">Covering Legends Like:</h3>
              <div className="flex flex-wrap gap-2">
                {artistData.coverArtists.map((artist, index) => (
                  <span
                    key={index}
                    className="bg-stone-800/50 border border-stone-700 text-stone-300 px-4 py-2 rounded-full text-sm hover:bg-gold-500/20 hover:border-gold-500/30 hover:text-gold-300 transition-all duration-200 cursor-default"
                  >
                    {artist}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
